import { CSSProperties } from 'react';
import { Icon, Tooltip, useTheme } from '../..';
import { TooltipPlacement } from '../../../common';
interface Props {
    size?: number;
    color?: string;
    text?: string;
    placement?: TooltipPlacement;
    wrapperSx?: CSSProperties;
    iconSx?: CSSProperties;
    iconName?: string;
}

const PargodaInfoIcon = (props: Props) => {
    const theme = useTheme();
    const {
        size = 24,
        color = theme.palette.secondary.main,
        text = '',
        placement = TooltipPlacement.TOP_START,
        wrapperSx,
        iconSx,
        iconName = 'InfoOutlinedIcon',
    } = props;
    return (
        <Tooltip title={text} placement={placement}>
            <div style={{ display: 'flex', ...wrapperSx }}>
                <Icon name={iconName} size={size} color={color} sx={iconSx} />
            </div>
        </Tooltip>
    );
};

export default PargodaInfoIcon;
